var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudentsActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.768,
    height: 11.459,
    viewBox: "0 0 19.768 11.459",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -166.422)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M165.6,404.131l-5.9-1.815v3.031c0,1.4,2.641,2.538,5.9,2.538s5.9-1.136,5.9-2.538c0-.011,0-.022,0-.033v-3Z",
    transform: "translate(-155.714 -230.005)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,170.225l2.107.754.18-.385.774-.066.11.115-.664.157-.1.286s-1.5,3.136-1.28,4.67a1.935,1.935,0,0,0,1.872,0l.249-4.194v-.349l1.393-.314-.1.242-1.039.338.48.172,5.9,1.815,5.9-1.815,3.987-1.426-9.884-3.8Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentsActive);
export default __webpack_public_path__ + "static/media/students-active.81ae602ae3415fdd3d6c287d29a0242a.svg";
export { ForwardRef as ReactComponent };